import config from 'config/config'
import React from 'react'
import { connect } from 'react-redux'
import { push } from 'react-router-redux'
import { bindActionCreators } from 'redux'
import { hideSidebar } from 'redux/navigation'
import { Menu } from 'semantic-ui-react'

const mapStateToProps = (state, ownProps) => {
  return {}
}

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(
    {
      push,
      hideSidebar,
    },
    dispatch
  )
}

class NavigationCategoriesLevel1 extends React.Component {
  render() {
    const { items, push, hideSidebar } = this.props

    const menuItems = items.map((item) => (
      <Menu.Item
        {...{
          children: item.content,
          active: item.active,
          href: item.path,
          key: item.key,
          onClick: (event) => {
            event.preventDefault()
            push(item.path)
            hideSidebar()
          },
        }}
      />
    ))

    return (
      <Menu color={config.semantic_ui.primary_color} pointing fluid secondary>
        {menuItems}
      </Menu>
    )
  }
}

NavigationCategoriesLevel1 = connect(mapStateToProps, mapDispatchToProps)(
  NavigationCategoriesLevel1
)
export default NavigationCategoriesLevel1



// WEBPACK FOOTER //
// ./src/components/shared/Navigation/renditions/NavigationCategoriesLevel1.jsx